import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getSurveyData } from './services/api';
import { handleCallNewsApp, h5PageCount, classNames } from '../../../utils';
import SurveyTitle from './surveyTitle';
import SurveyContent from './surveyContent';

const { callApp } = require('@ifeng/callapp');

class Survey extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
        pageInfo: PropTypes.object,
        clickCount: PropTypes.array,
        shareSurveyStyle: PropTypes.bool,
        isShowCallup: PropTypes.bool,
    };

    state = {
        data: {},
        status: '0',
        selectValue: {},
        valueCheck: [],
        resultShow: false,
        isSubmit: false,
    };

    async componentDidMount() {
        try {
            const { surveyId } = this.props;

            const data = await getSurveyData(surveyId);

            if (data.ifsuccess) {
                // console.log(data.data);

                this.setState({
                    data: data.data,
                    status: data.data.surveyinfo.status,
                    // expire '0' 过期 '1' 过期
                    resultShow: data.data.surveyinfo.expire === '0',
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    handleCallupFn = () => {
        const { pageInfo, clickCount, shareSurveyStyle } = this.props;
        const nodata = '';
        const doc_type = pageInfo.type === 'article' ? 'doc' : pageInfo.type;
        const aid = `ucms_${pageInfo.base62Id}`;
        const to_url = location.href;

        h5PageCount(
            clickCount || [
                {
                    behavior: 'action',
                    type: 'vote',
                    other: {
                        ref: `ucms_${pageInfo.base62Id}`,
                        kind: 'article',
                    },
                },
            ],
        );
        if (shareSurveyStyle) {
            callApp({
                client: 'newsApp',
                docType: pageInfo.type,
                pid: `${pageInfo.base62Id}`,
            });
        } else {
            handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, 'default_vote');
        }
    };

    render() {
        const { data, status, resultShow } = this.state;
        const { shareSurveyStyle, isShowCallup = true } = this.props;

        const pageUrl = location.href;
        const isShowCallupDom = pageUrl.indexOf('ishare.ifeng.com') !== -1;

        const callupDom = isShowCallupDom && isShowCallup && (
            <div className={styles.surveyCallup_box}>
                <section className={styles.surveyCallup} onClick={this.handleCallupFn}>
                    去凤凰新闻 参与投票
                </section>
            </div>
        );

        return (
            status === '1' && (
                <Fragment>
                    <div className={styles.survey_box}>
                        {!shareSurveyStyle && <SurveyTitle id={data.surveyinfo.id} title={data.surveyinfo.title} />}
                        <div
                            className={classNames(
                                styles.survey_content,
                                styles[shareSurveyStyle && 'shareSurveyStyle'],
                            )}>
                            <SurveyContent data={data} resultShow={resultShow} />
                        </div>
                    </div>
                    {callupDom}
                </Fragment>
            )
        );
    }
}

export default Survey;
